import { useEffect, useState } from 'react'

/** 仅在浏览器环境可靠；服务端/首帧为 false，避免误判为宽屏 */
export function useMediaQuery(query: string): boolean {
  const get = () =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false

  const [matches, setMatches] = useState(get)

  useEffect(() => {
    const m = window.matchMedia(query)
    const sync = () => setMatches(m.matches)
    sync()
    m.addEventListener('change', sync)
    return () => m.removeEventListener('change', sync)
  }, [query])

  return matches
}
